import { NavLink, Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { LayoutDashboard, Package, FileText, Users, ShoppingBag, RefreshCw, Trash2 } from "lucide-react";

export default function AdminLayout() {
  const linkCls = ({ isActive }) =>
    `flex items-center gap-2 px-3 py-2 text-sm transition-colors ${isActive ? "bg-[#002fa7] text-white" : "text-gray-700 hover:bg-gray-100"}`;

  const items = [
    { to: "/admin", end: true, icon: LayoutDashboard, label: "Overview", testid: "admin-nav-overview" },
    { to: "/admin/products", icon: Package, label: "Products", testid: "admin-nav-products" },
    { to: "/admin/orders", icon: ShoppingBag, label: "Orders", testid: "admin-nav-orders" },
    { to: "/admin/invoices", icon: FileText, label: "Invoices", testid: "admin-nav-invoices" },
    { to: "/admin/customers", icon: Users, label: "Customers", testid: "admin-nav-customers" },
    { to: "/admin/trash", icon: Trash2, label: "Trash", testid: "admin-nav-trash" },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-8 grid md:grid-cols-12 gap-8">
        <aside className="md:col-span-3 lg:col-span-2">
          <div className="border border-gray-200 p-2 sticky top-20">
            <div className="px-3 py-2 text-xs uppercase tracking-[0.2em] text-gray-500 font-medium">Admin</div>
            <nav className="flex flex-col gap-1">
              {items.map((it) => (
                <NavLink key={it.to} to={it.to} end={it.end} className={linkCls} data-testid={it.testid}>
                  <it.icon className="w-4 h-4" strokeWidth={1.5}/> {it.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </aside>
        <main className="md:col-span-9 lg:col-span-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
